import {Injectable} from '@angular/core';

@Injectable()
export class CsAgGridJsScriptHandlerService {

    private scriptElement: HTMLScriptElement | null = null;
    private isLoaded = false;
    private loadPromise: Promise<void> | null = null;
    private scriptUrl = 'https://cdn.jsdelivr.net/npm/ag-grid-enterprise@33.1.0/dist/ag-grid-enterprise.min.js';

    constructor() {
    }

    /* Note: Handling the ag-grid CDN script dynamically.
     - Due to the issue of conflicting the styles & functionalities b/w AG-Grid Angular & AG-Grid Js approaches.
     */
    async loadAgGridScript(): Promise<void> {
        if (this.isLoaded || (window as any).agGrid) {
            return Promise.resolve(); // ag-Grid is already in memory, no need to reload
        }

        if (this.loadPromise) {
            return this.loadPromise;
        }

        this.loadPromise = new Promise((resolve, reject) => {
            this.scriptElement = document.createElement('script');
            this.scriptElement.src = this.scriptUrl;
            this.scriptElement.async = true;
            this.scriptElement.onload = () => {
                this.isLoaded = true;
                resolve();
            };
            this.scriptElement.onerror = () => {
                this.isLoaded = false;
                this.loadPromise = null;
                reject(new Error('Failed to load ag-Grid JS'));
            };

            document.body.appendChild(this.scriptElement);
        });

        await this.isGridInstanceAvailable();

        return this.loadPromise;
    }

    isGridInstanceAvailable(): Promise<void> {
        // Wait until ag-Grid JS is fully available
        return new Promise<void>((resolve) => {
            const interval = setInterval(() => {
                if ((window as any).agGrid && (window as any).agGrid.createGrid) {
                    clearInterval(interval);
                    resolve();
                }
            }, 50);
        });
    }

    removeAgGridScript() {
        if (this.scriptElement) {
            this.scriptElement.remove(); // Detach from DOM but keep in memory
            this.scriptElement = null;
        }
    }

    // -------------------------------------------------------------------------------------------------------------
}
